const metric_map = {
    "Endurance": ["VO2 Max"],
    "Strength & Power": ["1RM"],
    "Recovery": ["HRV"],
    "Sleep Quality": ["REM Sleep", "Deep Sleep"],
    "Falling Asleep": ["Sleep Latency"],
    "Staying Asleep": ["Sleep Disturbances"],
    "Energy": ["RHR", "HRV"],
    "Fat Loss": ["BMR"]
}



let metrics = {
    "VO2 Max": 0,
    "1RM": 0,
    "HRV": 0,
    "REM Sleep": 0,
    "Deep Sleep": 0,
    "Sleep Latency": 0,
    "Sleep Disturbances": 0,
    "RHR": 0,
    "BMR": 0
}


const order = {
    "HRV": 1,
    "VO2 Max": 2,
    "Deep Sleep": 3,
    "REM Sleep": 4,
    "RHR": 5,
    "1RM": 6,
    "Sleep Latency": 7,
    "BMR": 8,
    "Sleep Disturbances": 9
}

const RANKED_CAP = 6;



async function getBenefits() {
    let benefits = {};
    console.log('benefits', benefits);
    if (typeof window !== "undefined" && window.sortedNeeds && typeof window.sortedNeeds === "object") {
        for (const key in window.sortedNeeds) {
            const val = window.sortedNeeds[key];
            if (val !== 0) benefits[key] = val;
        }
    }
    console.log('benefits', benefits);
    const recommendation = (typeof window !== "undefined" && window.currentRecommendations && typeof window.currentRecommendations === "object")
        ? window.currentRecommendations
        : {};
    const cart = (typeof window !== "undefined" && window.currentSupplementCart && typeof window.currentSupplementCart === "object")
        ? window.currentSupplementCart
        : {};
    const cartNames = Object.keys(cart);
    const allCartInRecommendation = cartNames.every(function (name) { return recommendation.hasOwnProperty(name); });
    if (allCartInRecommendation) return benefits;

    for (let i = 0; i < cartNames.length; i++) {
        const supplementName = cartNames[i];
        if (recommendation.hasOwnProperty(supplementName)) continue;
        const scoreMap = supplementToBenefitScore[supplementName];
        if (!scoreMap) continue;
        for (const benefit in scoreMap) {
            benefits[benefit] = (benefits[benefit] || 0) + scoreMap[benefit];
        }
    }
    console.log('benefits', benefits);
    return benefits;
}

async function aggregateBenefitsToMetrics(benefits) {
    for (const k in metrics) metrics[k] = 0;
    for (let benefit in benefits) {
        let benefitValue = benefits[benefit];
        // Check if this benefit exists in metric_map
        if (metric_map.hasOwnProperty(benefit)) {
            // Get the metrics associated with this benefit
            let metricsForBenefit = metric_map[benefit];
            // Iterate through each metric
            for (let i = 0; i < metricsForBenefit.length; i++) {
                let metricKey = metricsForBenefit[i];
                // Add the benefitValue to the metric's value in metrics
                if (metrics.hasOwnProperty(metricKey)) {
                    metrics[metricKey] += benefitValue;
                }
            }
        }
    }
}

// Compare two metrics: highest value wins; if tied, lower order number wins (1 = first, 9 = last)
function compareMetrics(aKey, bKey) {
    let aVal = metrics[aKey];
    let bVal = metrics[bKey];
    if (bVal !== aVal) return bVal - aVal;  // higher value first
    return (order[aKey] ?? 99) - (order[bKey] ?? 99);  // lower order number first
}

// Returns metric keys sorted by: value desc, then order asc (1 first, 9 last). Capped at RANKED_CAP. Excludes metrics with score 0.
function getMetricsRanked() {
    return Object.keys(metrics)
        .filter(function (key) { return metrics[key] !== 0; })
        .sort((a, b) => compareMetrics(a, b))
        .slice(0, RANKED_CAP);
}

// --- Metric graph data from supplement_metrics (ordered by day) ---

function parsePct(s) {
    if (typeof s !== "string") return 0;
    const t = s.trim().replace(/%$/, "").replace(/^\+/, "");
    return parseFloat(t) || 0;
}

// Normalize metric value to array of [week, treatmentPct].
// Supports: (1) new format { "8": { placebo, treatment }, "12": { ... } }
//           (2) legacy format { placebo, treatment, weeks }
function metricValueToPoints(m) {
    if (!m || typeof m !== "object") return [];
    if (typeof m.weeks === "number" && "treatment" in m) {
        return [[m.weeks, parsePct(m.treatment)]];
    }
    const points = [];
    for (const [weekStr, data] of Object.entries(m)) {
        const w = parseInt(weekStr, 10);
        if (Number.isNaN(w) || !data || typeof data !== "object") continue;
        if ("treatment" in data) points.push([w, parsePct(data.treatment)]);
    }
    return points;
}

async function collectMetricPoints(supplementMetrics) {
    const chosenNames = new Set(Object.keys(window.currentSupplementCart || {}));
    const byMetric = {};
    for (const sup of supplementMetrics.supplements) {
        if (!chosenNames.has(sup.name)) continue;
        for (const [metricName, m] of Object.entries(sup.metrics)) {
            if (!byMetric[metricName]) byMetric[metricName] = [];
            for (const [week, pct] of metricValueToPoints(m)) {
                byMetric[metricName].push([week, pct]);
            }
        }
    }
    const result = {};
    for (const [metricName, points] of Object.entries(byMetric)) {
        const byWeek = {};
        for (const [w, v] of points) {
            if (!byWeek[w]) byWeek[w] = [];
            byWeek[w].push(v);
        }
        const sortedWeeks = Object.keys(byWeek).map(Number).sort((a, b) => a - b);
        result[metricName] = sortedWeeks.map(w => {
            const vals = byWeek[w];
            return [w, vals.reduce((a, b) => a + b, 0) / vals.length];
        });
    }
    return result;
}

function interpolateSegment(dayStart, dayEnd, valStart, valEnd, random) {
    const n = dayEnd - dayStart - 1;
    if (n <= 0) return [];
    const delta = valEnd - valStart;
    const sign = delta >= 0 ? 1 : -1;
    const absDelta = Math.abs(delta);
    const weights = [];
    for (let i = 0; i < n; i++) weights.push(random());
    const total = weights.reduce((a, b) => a + b, 0);
    return weights.map(w => sign * (w / total) * absDelta);
}

function buildDailySeries(orderedPoints, maxWeeks, seed) {
    const numDays = maxWeeks * 7;
    const values = new Array(numDays + 1);
    values[0] = 0;

    let points = [[0, 0]].concat(orderedPoints);
    if (orderedPoints.length && orderedPoints[orderedPoints.length - 1][0] < maxWeeks) {
        const [lastW, lastV] = orderedPoints[orderedPoints.length - 1];
        points = points.concat([[maxWeeks, lastV]]);
    } else if (!orderedPoints.length) {
        points = [[0, 0], [maxWeeks, 0]];
    }

    const rng = (function (s) {
        return function () {
            s = (s * 1103515245 + 12345) & 0x7fffffff;
            return s / 0x7fffffff;
        };
    })(seed);

    for (let i = 0; i < points.length - 1; i++) {
        const [w0, v0] = points[i];
        const [w1, v1] = points[i + 1];
        const d0 = w0 * 7, d1 = w1 * 7;
        values[d0] = v0;
        values[d1] = v1;
        const increments = interpolateSegment(d0, d1, v0, v1, rng);
        let cur = v0;
        for (let k = 0; k < increments.length; k++) {
            cur += increments[k];
            values[d0 + 1 + k] = Math.round(cur * 1e4) / 1e4;
        }
    }

    const lastVal = values[numDays] != null ? values[numDays] : (orderedPoints.length ? orderedPoints[orderedPoints.length - 1][1] : 0);
    for (let i = 0; i <= numDays; i++) {
        if (values[i] == null) values[i] = lastVal;
    }
    return values;
}

/**
 * Build per-metric graph data from supplement_metrics.json.
 * Returns { metrics: { [metricName]: { max_weeks, num_days, known_points, values_by_day } } }
 * values_by_day is in day order: [day0, day1, ..., dayN] (length num_days + 1).
 */
async function getMetricGraphs(seed) {
    let supplementMetrics = null;
    if (typeof supplement_metrics !== "undefined") {
        supplementMetrics = supplement_metrics;
    } else {
        return { metrics: {} };
    }

    const benefits = await getBenefits();
    await aggregateBenefitsToMetrics(benefits);

    console.log(metrics);
    console.log("Ordered (top " + RANKED_CAP + "):", getMetricsRanked());

    if (!supplementMetrics || !supplementMetrics.supplements) return { metrics: {} };
    seed = seed ?? 42;
    const metricPoints = await collectMetricPoints(supplementMetrics);
    const graphs = {};
    for (const [metricName, points] of Object.entries(metricPoints)) {
        if (!points.length) continue;
        const maxWeeks = Math.max(...points.map(p => p[0]));
        const numDays = maxWeeks * 7;
        const valuesByDay = buildDailySeries(points, maxWeeks, seed);
        graphs[metricName] = {
            max_weeks: maxWeeks,
            num_days: numDays,
            known_points: points.map(([w, v]) => ({ weeks: w, day: w * 7, value: Math.round(v * 1e4) / 1e4 })),
            values_by_day: valuesByDay
        };
    }
    // Reorder graphs by getMetricsRanked(): ranked metrics first, then the rest
    const ranked = getMetricsRanked();
    const orderedGraphs = {};
    for (const metricName of ranked) {
        if (graphs[metricName]) orderedGraphs[metricName] = graphs[metricName];
         console.log('ranked before second pass for metric:', metricName, orderedGraphs )
    }
    for (const [metricName, data] of Object.entries(graphs)) {
        if (!orderedGraphs[metricName]) orderedGraphs[metricName] = data;
    }
    window.metricsGraphs = orderedGraphs;
    console.log(window.metricsGraphs)
    window.dispatchEvent(new CustomEvent("metricsGraphsReady", { detail: { graphs: orderedGraphs } }));
}

function runMetricGraphs() {
    getMetricGraphs().catch(err => console.error("getMetricGraphs failed:", err));
}

if (typeof window !== "undefined") {
    window.addEventListener("protocolDataFetch", runMetricGraphs);
    window.addEventListener("cartChangedPreCheckout", runMetricGraphs);
    window.addEventListener("quizDataFetch", runMetricGraphs);
}
